<template>
  <div class="following" v-if="isAuthenticated">
    <b-btn
      pill
      variant="primary"
      size="sm"
      @click="followTeacher"
      v-if="!isFollowing"
    >
      <span class="">Follow</span>
    </b-btn>
    <b-btn
      pill
      class="unfollow"
      variant="primary"
      size="sm"
      @mouseover="buttonText = 'Unfollow'"
      @mouseout="buttonText = 'Following'"
      v-if="isFollowing"
      @click="unFollowTeacher"
    >
      <span class="">{{ buttonText }}</span>
    </b-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { customerApi } from "../../services/customerApi";

export default {
  name: "FollowButton",
  computed: {
    ...mapGetters("user", ["isAuthenticated"]),
    ...mapGetters("teacher", ["getAllTeachers"])
  },
  data() {
    return {
      buttonText: "Following"
    };
  },
  methods: {
    followTeacher() {
      const teacherData = {
        user_id: this.teacherId
      };
      customerApi.followTeacher(teacherData).then(res => {
        this.isFollowing = true;
        customerApi.getFollowingTeachers();
      });
    },
    unFollowTeacher() {
      const teacherData = {
        teacher_id: this.teacherId
      };
      customerApi.unfollowTeacher(teacherData).then(res => {
        this.isFollowing = false;
        customerApi.getFollowingTeachers();
        this.getAllTeachers.forEach(teacher => {
          if (teacher.teacher_id === this.teacherId) {
            teacher.isFollowing = false;
          }
        });
      });
    }
  },
  props: {
    teacherId: String,
    isFollowing: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped></style>
